import React from 'react';
import './App.css';
import './index.scss';
import Router from './app/utill/router/router';
import ErrorBoundary from './app/shared/errorBoundary/ErrorBoundary';

// ErrorBoundary wraps Router so any render-time exception in any route surfaces a
// friendly fallback instead of a blank white page. Async errors (fetch / Promise
// rejection) still flow through toUserError + InlineAlert / ToastAlert as before.
function App(props) {
  return (
    <div className="App">
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
    </div>
  );
}

export default App;
